import React from 'react';
import './App.scss';
import {ConfigProvider} from 'antd'
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './pages/auth/login/login';
import TOTP from './pages/auth/totp/totp';
import Panel from './pages/panel/panel';
import { ToastContainer } from 'react-toastify';
import fa_IR from "antd/lib/locale/fa_IR";
import { JalaliLocaleListener } from 'antd-jalali';

function App() {
  return (
    <ConfigProvider locale={fa_IR} direction='rtl' theme={{
      token: {
        colorPrimary: '#023FA0',
        fontFamily: "Yekan Bakh FaNum",
      }
    }}>
      <JalaliLocaleListener />
      <ToastContainer />
      
      <Routes>
        <Route path="/" element={<Navigate to={"/auth/login"} />} />
        <Route path='/auth/login' element={<Login />} />
        <Route path='/auth/totp' element={<TOTP />} />
        <Route path='/panel/*' element={<Panel />} />
      </Routes>

    </ConfigProvider>
    
  );
}

export default App;
